import script from "./AudienceManager.vue?vue&type=script&setup=true&lang=ts"
export * from "./AudienceManager.vue?vue&type=script&setup=true&lang=ts"

import "./AudienceManager.vue?vue&type=style&index=0&id=875cdd6e&lang=scss"

const __exports__ = script;

export default __exports__